<div class="block" data-qa-block="cto-item">
  <div class="layout-two-rows">
    <div class="block-line">
      <div [ngSwitch]="contract.status">
        <ng-template ngSwitchCase="1">
          <svg-icon key="time" class="grey-icon"></svg-icon>
        </ng-template>
        <ng-template ngSwitchCase="5">
          <svg-icon key="time" class="grey-icon"></svg-icon>
        </ng-template>
        <ng-template ngSwitchCase="2">
          <svg-icon key="cto"></svg-icon>
        </ng-template>
        <ng-template ngSwitchDefault>
          <svg-icon key="block" class="grey-icon"></svg-icon>
        </ng-template>
      </div>
      <span class="bold-text" data-qa="cto-name">{{ contract.cto.name }}</span>
    </div>
    <div class="block-line grey-text">
      <svg-icon
        [ngClass]="{ invisible: !contract?.containsActionRequests }"
        key="sim-card"
        class="orange-icon"
      ></svg-icon>
      <span>
        <span data-qa="iin-bin">{{ contract.cto.iinOrBin }}</span>
        <span data-qa="address">{{ contract.cto.address }}</span>
        <span data-qa="contacts">{{ contract.cto.contacts }}</span>
      </span>
    </div>
  </div>

  <div class="layout-two-rows">
    <!--TODO: fix $any-->
    <tax-cto-status
      [createdAt]="$any(contract.createdAt)"
      [updatedAt]="$any(contract?.updatedAt)"
      [endsAt]="$any(contract?.endsAt)"
      [status]="$any(contract.status)"
    ></tax-cto-status>
    <div class="grey-text right-corner">
      <span data-qa="cto-retail-places">
        {{ 'cto.contract.retail.place.count' | translate }}
        {{ calculateRetailPlaceCount(contract.kkms) }}
      </span>
      <span class="extra-space" data-qa="cto-kkms">
        {{ 'cto.contract.kkm.count' | translate }}
        {{ calculateKkmCount(contract.kkms) }}
      </span>
    </div>
  </div>
</div>
